import mAxios from './m-axios'
import {newUser, User} from './user'

export interface Suggestion {
  suggestion_id: string
  info: string
  user: User
}

export const newSuggestion = (): Suggestion => ({
  suggestion_id: '',
  info: '',
  user: newUser(),
})

export const addSuggestion = (su: Suggestion) => {
  return mAxios({
    method: 'post',
    url: '/api/suggestion',
    data: su,
  })
}
